<template>
  <div
    class="column flex mt-5 registration-padding"
    :class="{ mobile: $vuetify.breakpoint.smAndDown }"
  >
    <div class="column flex relative" style="max-width: 840px">
      <EventKindCard
        v-for="kind in kinds"
        :key="kind.title"
        :kind="kind"
        class="mb-3"
        @click.native="selectKind(kind)"
      />
    </div>
  </div>
</template>

<script>
import EventKindCard from "@/components/Events/Cards/Kind";
import getPossibleStages from "@/helpers/events/getPossibleStages";

import { mapState } from "vuex";

export default {
  name: "EventKind",

  components: {
    EventKindCard,
  },

  props: {},
  data() {
    return {};
  },

  computed: {
    ...mapState(["community"]),

    kinds() {
      return getPossibleStages(this.community);
    },
  },

  methods: {
    selectKind(kind) {
      if (!kind || !kind.active) return;

      this.$emit("selectedEventKind", kind);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Registration/Steps/EventKind.vue